<template>
  <div class="lessons">
    <nav-bar/>
    <div class="page-header">
      <h1>Lessons</h1>
      <p>Pelajari dan kuasai elemen-elemen dari <i>computational thinking</i>!</p>
    </div>
    <div class="grid-container">
      <div class="lesson-item" v-for="(lesson, index) in LessonsStructure" :key="lesson.id">
        <div class="flex align-items-center lesson" @click="toggleTab(index)">
          <div class="icon-container" :class="{'icon-active': opened[index]}">
            <i class="fas" :class="`fa-${lesson.icon}`"/>
            <span>{{index + 1}}</span>
          </div>
          <div class="heading-container">
            <h1 :class="{'text-active': opened[index]}">{{lesson.name}}</h1>
            <p v-html="lesson.description"/>
            <div class="mt-1" v-if="!opened[index]">
              <small class="lesson-overview" v-for="(subLesson, index) in lesson.child" :key="subLesson.id">
                <b>{{index + 1}}.</b> {{subLesson.name}}
                <i class="fas fa-check-circle" v-if="getScore(lesson.id, subLesson.id)>99.99"></i>
              </small>
            </div>
          </div>
        </div>
        <div class="child-wrapper" :style="{height: opened[index] ? `${scrollIndexes[index]}px` : '1rem'}" ref="wrappers">
          <transition name="slide-top-slower">
            <div class="child-section" v-if="opened[index]">
              <div v-for="(subLesson, index) in lesson.child" class="child-heading" :key="subLesson.id">
                <div class="child-icon">
                  <i class="fas fa-check-circle" v-if="getScore(lesson.id, subLesson.id)>99.99"></i>
                  <span v-else>{{index + 1}}</span>
                </div>
                <div class="description-container">
                  <h2>
                    {{subLesson.name}}
                  </h2>
                  <p v-html="subLesson.description"/>
                  <div class="flex">
                    <div>
                      <b><small>Reward</small></b><br>
                      <b>{{subLesson.xp}}</b><small>XP</small>
                    </div>
                    <div class="ml-2">
                      <b><small>Rekorku</small></b><br>
                      <b>{{getScore(lesson.id, subLesson.id, true)}}</b>
                    </div>
                  </div>
                  <router-link class="btn btn--blue btn--tab" :to="{ name: 'lessonsActivity', params: { id: lesson.id, subId: subLesson.id} }">Mulai!</router-link>
                </div>
              </div>
              <div class="child-end" v-if="LessonsStructure.length - 1 === index">
                <div class="child-icon"/>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <footer-bar/>
  </div>
</template>

<script>
  import NavBar from '@/components/NavBar'
  import FooterBar from '@/components/FooterBar'
  import LessonsStructure from './LessonsPayload/LessonsStructure'

  export default {
    name: 'LessonsRoot',
    components: {
      FooterBar,
      NavBar
    },
    data() {
      return {
        LessonsStructure,
        opened: [],
        lastToggledIndex: 0,
        scrollIndexes: [],
        score: []
      }
    },
    computed: {
      userDataStore() {
        return this.$store.state.userStore
      },
    },
    created() {
      let arraySize = LessonsStructure.length
      while(arraySize--) this.opened[arraySize] = true
      this.filterFinishedTask()
    },
    mounted() {
      let wrapperTotal = this.$refs.wrappers.length
      while(wrapperTotal--) this.scrollIndexes[wrapperTotal] = this.$refs.wrappers[wrapperTotal].scrollHeight
      for (let i in this.opened) this.$set(this.opened, i, false)
    },
    methods: {
      toggleTab(index) {
        this.$set(this.opened, this.lastToggledIndex, false)
        this.lastToggledIndex = index
        this.opened[index] = this.$set(this.opened, index, !this.opened[index])
      },
      arrayToObject(array, keyField, subKeyField) {
        return array.reduce((obj, item) => {
          if (!obj[item[keyField]]) {
            obj[item[keyField]] = {}
          }
          obj[item[keyField]][item[subKeyField]] = item
          return obj
        }, {})
      },
      filterFinishedTask() {
        const array = this.userDataStore.finishedTask.filter(item => item.type === 'lesson')
        this.score = this.arrayToObject(array, 'lessonsId', 'subLessonsId')
      },
      isScoreExist(id, subId) {
        return this.score[id] && this.score[id][subId]
      },
      getScore(id, subId, percent) {
        return this.isScoreExist(id, subId) ? this.score[id][subId].score.toFixed(2) + (percent?'%':'') : '---'
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/styles/colors";
  @import "src/styles/responsive";

  .lesson {
    transition: all 0.1s;
    border-radius: 10px;

    &:hover {
      transform: translateY(1px);
      background-color: rgba(black, 0.1);
      cursor: pointer;
    }

    &:active {
      transform: translateY(5px);
    }
  }

  .icon-container {
    height: 100px;
    width: 100px;
    border-radius: 10px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(to bottom right, #6f5da8, #1F2041);
    box-shadow: 0 10px 10px 0 rgba(black, 0.2);
    position: relative;
    overflow: hidden;
    z-index: 0;
    transition: filter 0.3s;

    i {
      position: absolute;
      font-size: 85px;
      top: 20px;
      right: -10px;
      color: white;
      opacity: 1;
      transform: rotate(-15deg);
      mix-blend-mode: overlay;
      z-index: 0;
    }

    span {
      font-size: 2rem;
      color: white;
      font-weight: bold;
    }
  }

  .icon-active {
    filter: brightness(200%);

    i {
      text-shadow: 0 0 20px white;
    }

    span {
      color: rgba(black, 0.5);
    }
  }

  .heading-container {
    margin-left: 1rem;

    h1 {
      background: linear-gradient(to bottom right, #6f5da8, #1F2041);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      transition: filter 0.5s;
    }
  }

  .text-active {
    filter: brightness(150%);
  }

  .lesson-overview {
    padding: 0.2rem 0.5rem;
    margin-right: 0.2rem;
    background-color: rgba(black, 0.1);
    border-radius: 10px;
    color: $text;

    @include mobile {
      display: none;
    }
  }

  .child-wrapper {
    transition: height 0.2s;
    overflow: hidden;
  }

  .child-section {
    margin-left: 48px;
    padding: 1rem 0;
    border-left: 4px dotted #1F2041;
  }

  .lesson-item:last-of-type {
    .child-section {
      padding-bottom: 0;
    }
  }

  .child-heading {
    display: flex;
    margin-bottom: 1.5rem;

    a {
      display: inline-block;
    }
  }

  .child-icon {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    box-sizing: border-box;
    background-color: white;
    border: 2px solid #1F2041;
    font-weight: 900;
    margin-left: -17px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1F2041;

    .fas {
      font-size: 1.35rem;
    }
  }

  .child-end > .child-icon {
    height: 80px;
    margin-top: -50px;
    background: linear-gradient(to bottom, rgba(white, 0), white);
    border: unset;
  }

  .description-container {
    margin-left: 1rem;

    h2 {
      font-weight: 600;
      font-size: 1.5rem;
      color: #1F2041;
    }

    div {
      margin-bottom: 0.5rem;
    }
  }

  .dark-mode {
    .child-section {
      border-color: #846fc8;
    }
    .child-icon {
      border-color: #957de2;
      color: #957de2;
      background-color: $dark-mode-back-primary;
    }
    .lesson:hover {
      background-color: rgba(black, 0.3);
    }
    .description-container > h2 {
      color: #957de2;
    }
    .heading-container > h1 {
      filter: brightness(2) contrast(0.75);
    }
    .lesson-overview {
      background-color: #1F2041;
      color: $light-gray;
    }
    .child-end > .child-icon {
      background: linear-gradient(to bottom, rgba($dark-mode-back-primary, 0), $dark-mode-back-primary);
    }
  }
</style>
